<div id="cscText">
  <div id="cscText_1" class="cscText">C</div>
  <div id="cscText_2" class="cscText">S</div>
  <div id="cscText_3" class="cscText">C</div>
</div>
